import { TermsListSpace } from 'src/types/api'
import { AllTermsBooleanType } from 'src/types/react-hook-form'

type TermsData = TermsListSpace.AllTermsType & { Idx?: number }

const isTermItem = (value: unknown): value is TermsListSpace.TermItemsType =>
  typeof value === 'object' && value !== null && 'Required' in value

export function isTermRequired(key: keyof AllTermsBooleanType, termsData: TermsData) {
  const term = termsData[key as keyof TermsData]
  return isTermItem(term) && term.Required === 1
}

export function getRequiredTermKeys(termsData: TermsData) {
  return Object.entries(termsData).reduce<string[]>((list, [key, value]) => {
    if (isTermItem(value) && value.Required === 1) {
      list.push(key)
    }
    return list
  }, [])
}
